(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collection-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fg-collection-description')) {
    customElements.define('fg-collection-description', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { if (this.isConnected) this.initialize(); }, { once: true });
        else this.initialize();
      }
      disconnectedCallback() { this.resizeObserver?.disconnect(); }
      initialize() {
        if (this.initialized || this.dataset.designMode === 'true') return;
        const body = this.querySelector('.fg-collection-description__body');
        const details = this.querySelector('details');
        const summary = details?.querySelector('summary');
        const heading = this.closest('.section-content-wrapper')?.querySelector('.fg-collection-heading');
        if (!body || !heading) return;
        this.initialized = true;
        const sync = () => { this.dataset.expanded = String(details ? details.open : true); };
        const measure = () => {
          const bodyStyle = getComputedStyle(body);
          const line = parseFloat(bodyStyle.lineHeight) || 24.5;
          const desktop = window.matchMedia('(min-width: 750px)').matches;
          const first = heading.querySelector('.text-block');
          const last = heading.querySelector('.fg-collection-heading__intro') || first;
          const naturalHeight = first && last ? last.getBoundingClientRect().bottom - first.getBoundingClientRect().top : 100;
          const height = desktop ? Math.max(3, Math.ceil(naturalHeight / line)) * line : 3 * line;
          this.style.setProperty('--fg-preview-height', `${height}px`);
          this.style.setProperty('--fg-preview-line', `${line}px`);
          this.style.setProperty('--fg-preview-font-size', bodyStyle.fontSize);
          heading.style.minHeight = desktop ? `${height}px` : '';
          if (details && summary) {
            const probe = body.cloneNode(true);
            probe.removeAttribute('id');
            for (const child of probe.querySelectorAll('[id]')) child.removeAttribute('id');
            probe.setAttribute('aria-hidden', 'true');
            probe.inert = true;
            probe.style.cssText = `position:absolute;visibility:hidden;pointer-events:none;width:${this.getBoundingClientRect().width}px;`;
            probe.style.fontSize = bodyStyle.fontSize;
            probe.style.lineHeight = `${line}px`;
            this.append(probe);
            const fits = probe.getBoundingClientRect().height <= height + 1;
            const preview = summary.querySelector('.fg-collection-description__preview');
            if (preview) {
              // The plain teaser may use fewer rows than the formatted body.
              // Keep the arrow on its last visible row, within the heading budget.
              probe.className = preview.className;
              probe.style.height = 'auto';
              probe.style.minHeight = '0';
              probe.textContent = preview.textContent;
              const teaserLines = Math.max(1, Math.round(probe.getBoundingClientRect().height / line));
              this.style.setProperty('--fg-collapsed-height', `${Math.min(height, teaserLines * line)}px`);
            }
            probe.remove();
            const previouslyFit = this.dataset.foldable === 'false';
            summary.hidden = fits;
            this.dataset.foldable = String(!fits);
            if (fits) details.open = true;
            else if (previouslyFit) details.open = false;
          }
          sync();
        };
        details?.addEventListener('toggle', () => {
          sync();
          if (!details.open && summary) {
            const bounds = summary.getBoundingClientRect();
            if (bounds.top < 0 || bounds.bottom > innerHeight) summary.scrollIntoView({ block: 'nearest', behavior: 'instant' });
          }
        });
        measure();
        this.resizeObserver = new ResizeObserver(measure);
        for (const element of [this, ...heading.children]) this.resizeObserver.observe(element);
        document.fonts?.ready.then(() => { if (this.isConnected) measure(); });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
